import { useDirection } from '@/entities/direction';
import { useRegionPrice, useStationInfo } from '@/entities/station';
import { GEOLOCATION_OPTIONS } from '@/shared/consts';
import { useLocation } from '@/shared/lib';
import { ProductCodeMap } from '@/shared/types';
import useNavigationDeepLink from '../lib/useNavigationDeepLink';
import useTransTM128ToLantLng from '../lib/useTransTM128ToLantLng';

const useStationPageData = (stationId: string | undefined) => {
	const { stationInfo } = useStationInfo(stationId);
	const gasStation = stationInfo?.RESULT.OIL[0];

	const stationLocation = useTransTM128ToLantLng(
		gasStation?.GIS_X_COOR,
		gasStation?.GIS_Y_COOR,
	);
	const { location: userLocation } = useLocation(
		undefined,
		GEOLOCATION_OPTIONS,
	);
	const { direction } = useDirection(
		stationId || '',
		userLocation,
		stationLocation,
	);

	const regionPrice = useRegionPrice(
		stationLocation?.lat,
		stationLocation?.lng,
	);

	const { launchNavigationApp } = useNavigationDeepLink({
		stationLocation,
		userLocation,
		stationName: gasStation?.OS_NM,
	});

	const distance = direction?.distance ?? null;

	const gasolinePrice = gasStation?.OIL_PRICE.find(
		(price) => price.PRODCD === ProductCodeMap.휘발유,
	)?.PRICE;
	const dieselPrice = gasStation?.OIL_PRICE.find(
		(price) => price.PRODCD === ProductCodeMap.경유,
	)?.PRICE;
	const gasolineAverage = regionPrice?.prices.find(
		(price) => price.prodcd === ProductCodeMap.휘발유,
	)?.price;
	const dieselAverage = regionPrice?.prices.find(
		(price) => price.prodcd === ProductCodeMap.경유,
	)?.price;

	return {
		gasStation,
		stationLocation,
		distance,
		regionPrice,
		gasolinePrice,
		dieselPrice,
		gasolineAverage,
		dieselAverage,
		launchNavigationApp,
	};
};

export default useStationPageData;
